<script setup lang="ts">
import {Motion} from 'motion-v'
import {ref} from 'vue'

const props = defineProps<{
  byteId: number
  card?: boolean
  copyText?: string
}>()

const copied = ref(false)

const copyToClipboard = async () => {
  try {
    // Copy the current page URL or use the provided copyText
    const textToCopy = props.copyText || window.location.href
    await navigator.clipboard.writeText(textToCopy)

    copied.value = true

    setTimeout(() => {
      copied.value = false
    }, 2000)
  } catch (err) {
    console.error('Failed to copy text: ', err)
  }
}
</script>

<template>
  <button
    v-if="card"
    @click.prevent="copyToClipboard"
    class="flex w-20 cursor-pointer flex-col items-center gap-x-1 rounded-md border border-gray-300 bg-gray-100 p-3 transition-colors duration-200 hover:bg-gray-300"
  >
    <AnimatePresence mode="popLayout">
      <Motion
        v-if="copied"
        :initial="{scale: 1, filter: 'blur(16px)'}"
        :animate="{scale: 1, filter: 'blur(0px)'}"
        :exit="{scale: 0, filter: 'blur(16px)'}"
      >
        <Icon size="16" class="text-gray-600" name="material-symbols:check" />
      </Motion>
      <Motion
        v-else
        :initial="{scale: 0, filter: 'blur(16px)'}"
        :animate="{scale: 1, filter: 'blur(0px)'}"
        :exit="{scale: 0, filter: 'blur(16px)'}"
      >
        <Icon size="16" class="text-gray-600" name="material-symbols:attachment" />
      </Motion>
    </AnimatePresence>

    <span class="text-sm text-gray-700">{{ copied ? 'Copied!' : 'Copy' }}</span>
  </button>

  <button
    v-else
    @click.prevent="copyToClipboard"
    class="flex cursor-pointer items-center gap-x-2 text-gray-600 transition-colors duration-200 hover:text-gray-800"
  >
    <AnimatePresence mode="popLayout">
      <Motion
        v-if="copied"
        :initial="{scale: 1, filter: 'blur(16px)'}"
        :animate="{scale: 1, filter: 'blur(0px)'}"
        :exit="{scale: 0, filter: 'blur(16px)'}"
      >
        <Icon size="18" class="text-gray-600" name="material-symbols:check" />
      </Motion>
      <Motion
        v-else
        :initial="{scale: 0, filter: 'blur(16px)'}"
        :animate="{scale: 1, filter: 'blur(0px)'}"
        :exit="{scale: 0, filter: 'blur(16px)'}"
      >
        <Icon size="18" class="text-gray-600" name="material-symbols:attachment" />
      </Motion>
    </AnimatePresence>

    <span class="text-sm">{{ copied ? 'Copied!' : 'Copy' }}</span>
  </button>
</template>
